import React from 'react';

export default function ProfileCapsule({ profile, onAddFriend }) {
  if (!profile) return null;

  const {
    avatar_or_pic,
    user_photo,
    user_avatar,
    first_name,
    last_name,
    avatar_nickname,
    bio,
    location,
    phone,
    user_email,
    backdrop,
    social_facebook,
    social_instagram,
    social_x,
    social_snapchat,
    social_whatsapp,
    social_tiktok,
    is_private,
    is_accepted
  } = profile;

  // 💡 Logic: If private + not a confirmed friend
  const isLocked = is_private && !is_accepted;

  const forcedAvatar = `https://api.dicebear.com/6.x/bottts-neutral/svg?seed=locked`;

  return (
    <div className="profile-enclosure">
      {backdrop && !isLocked && (
        <div className="backdrop-preview" style={{ backgroundImage: `url(${backdrop})` }} />
      )}

      <div className="profile-avatar-wrapper">
        <img
          src={
            isLocked
              ? forcedAvatar
              : avatar_or_pic === 'photo' && user_photo
              ? user_photo
              : user_avatar || forcedAvatar
          }
          className="profile-avatar"
          alt="Profile"
        />
      </div>

      <div className="profile-name">{first_name} {last_name}</div>

      {isLocked ? (
        <>
          <div className="profile-contact"><strong>City:</strong> {location}</div>
          <div className="profile-privacy-note">🔒 Private Account</div>
          <button onClick={() => onAddFriend(profile)} className="add-friend-btn">Add Friend</button>
        </>
      ) : (
        <>
          <div className="profile-bio">{bio}</div>
          <div className="profile-contact"><strong>City:</strong> {location}</div>
          <div className="profile-contact"><strong>Phone:</strong> {phone}</div>
          <div className="profile-contact"><strong>Nickname:</strong> {avatar_nickname}</div>
          <div className="profile-contact"><strong>Email:</strong> {user_email}</div>

          {!isLocked && (
              <div className="social-icons">
                {social_facebook && (
                  <a href={social_facebook} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook" />
                  </a>
                )}
                {social_instagram && (
                  <a href={social_instagram} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram" />
                  </a>
                )}
                {social_x && (
                  <a href={social_x} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-x-twitter" />
                  </a>
                )}
                {social_snapchat && (
                  <a href={social_snapchat} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-snapchat-ghost" />
                  </a>
                )}

                {social_whatsapp && (
                  <a href={social_whatsapp} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-whatsapp" />
                  </a>
                )}

                {social_tiktok && (
                  <a href={social_tiktok} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-tiktok" />
                  </a>
                )}
              </div>
            )}
        </>
      )}
    </div>
  );
}
